import { render, staticRenderFns } from "./MultiPaneLayout.vue?vue&type=template&id=5eb70bce&scoped=true"
import script from "./MultiPaneLayout.vue?vue&type=script&lang=js"
export * from "./MultiPaneLayout.vue?vue&type=script&lang=js"
import style0 from "./MultiPaneLayout.vue?vue&type=style&index=0&id=5eb70bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb70bce",
  null
  
)

export default component.exports